import axios from "axios";

export default {
  getAwardById(awardId) {
    return axios.get(process.env.VUE_APP_API_URL + "award/find/" + awardId).then((response) => {
      return response.data.data;
    });
  },
};
